import { HelpDialog } from '~/components/dialogs';
import { Link } from '~/components/link';
import { Text } from '~/components/typography';
import { TRACK } from '~/utils/tracking';

export const HelpText = ({ isSmb = false }: { isSmb?: boolean }) => {
  return (
    <HelpDialog
      isSmb={isSmb}
      target={
        <Text fontSize="small" display="inline-block" textAlign="left" color="secondary">
          Questions? Our Energy Advisors are just a click away.
          <Link
            color="primary"
            track={TRACK.supportLinkClicked}
            style={{
              whiteSpace: 'nowrap',
              display: 'inline-block',
              paddingLeft: 5,
            }}
          >
            <Text fontSize="small" textStyle="heading600">
              Contact us.
            </Text>
          </Link>
        </Text>
      }
    />
  );
};
